import React, { useEffect, useMemo, useState } from 'react'
import { isMobileSafari } from 'react-device-detect'

import config from 'config'
import Button from 'components/Button'

import logo from 'assets/images/logo.gif'

const HIDDEN_CLASS = 'overflow-hidden'

const Banner = ({ isOpen, onClose }) =>
  isOpen && (
    <div
      className="z-1000 fixed inset-0 h-screen w-full"
      style={{
        'user-drag': 'none',
        '-webkit-user-drag': 'none',
        zIndex: 100000,
      }}
    >
      <div className="h-full w-full text-white text-center font-ownersWide overflow-hidden">
        <div className="h-full flex flex-col items-center justify-between relative pt-14 pb-28 z-10 px-8">
          <div className="w-full">
            <div className="text-xl mb-4 font-medium text-center max-w-md">
              Apply for membership on our iOS app
            </div>
            <Button
              className="bg-azureRadiance mx-auto rounded-full h-12 px-8"
              onClick={() => window.open(config.ios.appLink, '_blank')}
            >
              <span className="text-xl font-medium font-ownersWide">Download</span>
            </Button>
          </div>
          <div className="w-full">
            <img src={logo} alt="logo" className="mx-auto w-20 mb-4" />
            <div className="text-2xl font-medium mb-6 text-center">Stay on Web</div>
            <Button className="w-full bg-white rounded-full h-14" onClick={onClose}>
              <span className="text-black">GET STARTED</span>
            </Button>
          </div>
        </div>
        <div
          className="absolute -top-5 left-0 h-72 w-full"
          style={{
            '-webkit-filter': 'blur(4px)',
            filter: 'blur(4px)',
            background:
              'linear-gradient(180deg, rgba(192, 206, 255, 0.90) 0%, rgba(0, 0, 0, 0.00) 100%)',
          }}
        />
        <div
          className="absolute inset-0 h-full w-full bg-black bg-opacity-90"
          style={{
            backdropFilter: 'blur(10px)',
            '-webkit-backdrop-filter': 'blur(10px)',
          }}
        />
      </div>
    </div>
  )

const useAppBanner = () => {
  const [showAppBanner, setShowAppBanner] = useState(isMobileSafari)

  useEffect(() => {
    if (showAppBanner) {
      document.documentElement.classList.add(HIDDEN_CLASS)
    } else {
      document.documentElement.classList.remove(HIDDEN_CLASS)
    }

    return () => document.documentElement.classList.remove(HIDDEN_CLASS)
  }, [showAppBanner])

  const AppBanner = useMemo(
    () => () => <Banner isOpen={showAppBanner} onClose={() => setShowAppBanner(false)} />,
    [showAppBanner]
  )

  return {
    showAppBanner,
    AppBanner,
  }
}

export default useAppBanner
